/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { useEffect } from "react";
import { toast } from "react-toastify";

import {
  _editChatMessage,
  _getAfterGroupRemovedData,
  _getAfterUserRemovedData,
  _getGroupAddedData,
  _getGroupUpdatedData,
  _getGroups,
  _getKeepAlive,
  _getMessageList,
  _getSearchChatMessage,
  _getUnreadMessageCountList,
  _getUserAddedData,
  _getUserUpdatedData,
  _getUsers,
  _getLoadMoreChatData,
  _getLogout,
  _sendChatRoomDetail,
  _sendUnreadMessageCountList,
  _socketConnect,
  _unreadMessageCountUpdate,
  clearUnreadCount,
  _getInstantCall,
  getAddedWhiteBoardElemets,
  getUpdateWhiteBoardElemets,
  getWhiteBoardElemets,
  getClearWhiteBoardData,
  getRaiseHandNotificaton,
  _getInstantCallReminder,
  _getScreenInfoNotify,
  _getScreenInfo,
  _getCallParticipants,
  _getCallDocUpdate,
  _getAddedCallParticipants,
  _searchChatMessage,
  _getChatRoomPinnedMessage,
  _getLoadMoreChatRoomPinnedMessage,
  _getChatRoomFiles,
  _getLoadMoreChatRoomFiles,
  _getUserCurrentSessionEnd,
  _sendChatRoomThreadDetail,
  _getThreadMessageList,
  _getUnreadThreadList,
  _sendClearUnreadThreadCount,
} from "../../SocketIo";
import { LOGOUT_CODE_PARAM, UPLOAD_API_URL } from "../../constants";
import store from "../../store";
import {
  setAuthSession,
  setAuthSessionUser,
  setAuthSuccess,
  setCompanyDetail,
  setErrorCode,
  setIsLoggedInAccountActive,
  setUserLoginToken,
} from "../redux/authUserDetail";
import {
  setAttachmentData,
  setAttendeeData,
  setAttendeeList,
  setBadWordList,
  setChatboardSelectedTab,
  setChatFiles,
  setChatRoom,
  setIsChatHistoryEnableOnce,
  setIsScrollingUp,
  setIsUploadingData,
  setLoaderActiveData,
  setMsgMentionId,
  setMsgMentionUser,
  setIsMentionInThread,
  setPinnedByUserProfileId,
  setPinnedChatMessage,
  setPopupClass,
  setRecentlyUsedEmoticons,
  setReplyMessage,
  setSearchChatData,
  setSelectedLanguage,
  setSidebarActiveData,
  setUnreadChatMessage,
  setUserProfileHoverId,
  setUserProfileId,
  setUserProfilePopPosition,
  setUserStaticInfo,
  updateFilesMessages,
  updatePinnedMessages,
  removeUnreadThread,
} from "../redux/chatSlice";
import PushNotification from "../util/PushNotification";
import { initdevices } from "./Lib";
import {
  CALL_TITLE,
  apiClient,
  blobToBase64,
  getAuthSession,
  grantCameraPermission,
  grantMicPermission,
  isElectron,
  logoutAllDevices,
  notifyDesktopApp,
  privateChatID,
  timestampToDateTimeFilter,
} from "./common";
import { alertMsg } from "../util/alertMsg";
import { fetchWasabiImageUploadURL } from "./wasabiFileUpload";
import { addFileData } from "../redux/fileSlice";
import { setVirtualBackgroundOptions } from "./Lib/libSlice";
import { getData, updateDataInDB } from "../util/indexedDB";

export const checkUserAccountExistApi = async (paramObj) => {
  try {
    const res = await apiClient("token", {
      method: "POST",
      data: paramObj,
    });

    if (res.status === 200) {
      return { res: res, status: true };
    } else {
      return { res: res, status: false };
    }
  } catch (e) {
    return { res: {}, status: false };
  }
};

export const userAccountExist = async (loginToken) => {
  const { dispatch } = store;
  const languageArr = ["en", "fr"];
  const accountData = await _socketConnect({ unique_token: loginToken });
  console.log("accountData checkkkkkk=>", accountData);
  dispatch(setAuthSession(accountData));
  if (accountData?.status == 200) {
    const userData = accountData?.data?.user ?? {};
    dispatch(
      setUserStaticInfo({
        user_id: userData?.user_id,
        company_id: userData?.company_id,
      }),
    );
    if (languageArr.includes(accountData?.data?.language)) {
      dispatch(setSelectedLanguage(accountData?.data?.language));
    }
    dispatch(setAuthSessionUser(userData));
    const virtual_background = userData?.virtual_background ?? {};
    dispatch(setVirtualBackgroundOptions(virtual_background));
    dispatch(
      setCompanyDetail({
        company_logo: accountData?.data?.company_logo,
        company_name: accountData?.data?.company_name,
        company_id: accountData?.data?.company_id,
        attachment_expire_seconds: accountData?.data?.attachment_expire_seconds,
        peek: accountData?.data?.peek,
        agent_to_all: accountData?.data?.agent_to_all,
        masking: accountData?.data?.masking,
      }),
    );
    dispatch(setBadWordList(accountData?.data?.bad_word_list));
    // dispatch(setBadWordList(["neha", "saini"]));
    dispatch(
      setRecentlyUsedEmoticons(accountData?.data?.recentlyUsedEmoticon ?? []),
    );
  } else {
    dispatch(setIsLoggedInAccountActive(true));
    dispatch(setErrorCode(accountData?.status));
  }
};

export const socketAllEventsOpen = (loginToken) => {
  const { dispatch } = store;
  dispatch(setUserLoginToken(loginToken));
  const initialState = {
    username: "",
    login_token: loginToken,
    user_unique_key: "",
    company_unique_key: "",
  };
  localStorage.setItem("auth_session", JSON.stringify(initialState));

  _getUsers();
  _getGroups();
  _getGroupUpdatedData();
  _getGroupAddedData();
  _getAfterGroupRemovedData();
  _getUserAddedData();
  _getUserUpdatedData();
  _getAfterUserRemovedData();
  _getUnreadMessageCountList();
  _getKeepAlive();
  _getLoadMoreChatData();
  _getSearchChatMessage();
  _getLogout();
  _getInstantCall();
  getAddedWhiteBoardElemets();
  getUpdateWhiteBoardElemets();
  getWhiteBoardElemets();
  getClearWhiteBoardData();
  getRaiseHandNotificaton();
  _getInstantCallReminder();
  _getScreenInfoNotify();
  _getScreenInfo();
  _getCallParticipants();
  _getCallDocUpdate();
  _getAddedCallParticipants();
  _getChatRoomPinnedMessage();
  _getLoadMoreChatRoomPinnedMessage();
  _getChatRoomFiles();
  _getLoadMoreChatRoomFiles();
  _getUserCurrentSessionEnd();
};

export const userGetVerifiedHandler = (authSession, loginToken, navigate) => {
  const { dispatch } = store;
  const initialState = {
    username: authSession?.data?.user_id,
    login_token: loginToken,
    user_unique_key: authSession?.data?.user_id,
    company_unique_key: authSession?.data?.company_id,
  };
  localStorage.setItem("auth_session", JSON.stringify(initialState));
  _sendUnreadMessageCountList({
    logged_user_id: authSession?.data?.user_id,
    company_id: authSession?.data?.company_id,
  });
  if (
    localStorage.getItem("avsetting") == undefined ||
    localStorage.getItem("avsetting") == null
  ) {
    let data = {
      speakerDevice: "",
      microphoneDevice: "",
      cameraDevice: "",
    };
    localStorage.setItem("avsetting", JSON.stringify(data));
  }

  initdevices(dispatch);
  grantMicPermission();
  grantCameraPermission();

  navigate("/");
  dispatch(setAuthSuccess(true));
};

export const clearUnreadCountHandler = () => {
  const state = store.getState();
  const { authSessionUser } = state.authUserDetail;
  clearUnreadCount({
    logged_user_id: authSessionUser?.user_id,
    company_id: authSessionUser?.company_id,
  }).then((res) => {
    if (res?.status === 200) {
      toast.success(alertMsg.countSuccess, {
        position: "top-center",
      });
    } else {
      toast.success(res.data.msg, {
        position: "top-center",
      });
    }
  });
};

export const logoutHandler = async () => {
  const state = store.getState();
  const { userLoginToken } = state.authUserDetail;
  const { dispatch } = store;
  const logoutPayload = {
    unique_token: userLoginToken,
  };
  const res = await logoutAllDevices(logoutPayload);
  if (res?.status == true) {
    dispatch(setIsLoggedInAccountActive(true));
    dispatch(setErrorCode(LOGOUT_CODE_PARAM));
  }
};

export const getUserListExceptLoggedInUser = () => {
  const state = store.getState();
  const { dispatch } = store;
  const { allAttendeeList } = state.call;
  const { user_unique_key } = getAuthSession();
  const { authSessionUser } = state.authUserDetail;
  if (allAttendeeList.length > 0) {
    let userDetails = allAttendeeList.filter(
      (att) => att?.user_id == user_unique_key,
    );
    if (userDetails.length > 0 && authSessionUser !== userDetails[0]) {
      dispatch(setAuthSessionUser(userDetails[0]));
    }
    let attendedList = allAttendeeList.filter(
      (att) => att?.user_id != user_unique_key,
    );
    dispatch(setAttendeeList(attendedList));
  }
};

export const getUserOrGroupListWithoutSearch = (type) => {
  const state = store.getState();
  const { unreadChatMessage, groupList, attendeeList } = state.chat;
  const { companyDetail, authSessionUser } = state.authUserDetail;
  let userList = attendeeList;
  if (authSessionUser?.role === "Agent") {
    if (!companyDetail.agent_to_all) {
      userList = attendeeList.filter((item) => item.role !== "Agent");
    }
  }
  const userOrGroupList = type === "group" ? groupList : userList;
  const userOrGroupListWithUnreadChatMessage = userOrGroupList.map((t1) => ({
    ...t1,
    ...unreadChatMessage.find(
      (ts) => ts.user_id === (type === "group" ? t1.groupId : t1.user_id),
    ),
  }));
  const userOrGroupWithoutConversation =
    userOrGroupListWithUnreadChatMessage.filter(
      (item) => item.timestamp === undefined,
    );
  const userOrGroupWithConversation =
    userOrGroupListWithUnreadChatMessage.filter(
      (item) => item.timestamp !== undefined,
    );
  let sortedDataWithLastActivity = userOrGroupWithConversation.sort(function (
    x,
    y,
  ) {
    return y.timestamp - x.timestamp;
  });
  if (userOrGroupWithoutConversation.length > 0) {
    sortedDataWithLastActivity.push(...userOrGroupWithoutConversation);
  }
  return sortedDataWithLastActivity;
};

const notificationAttendeeDetail = (senderId) => {
  const state = store.getState();
  const { allAttendeeList } = state.call;
  let sender = "";
  let useravtar = "";
  allAttendeeList.some((v) => {
    if (v?.user_id == senderId) {
      sender = v.name;
      useravtar = v.user_profile_image;
    }
  });
  return { sender, useravtar };
};

const getGroupDetail = (groupId) => {
  const state = store.getState();
  const { groupList } = state.chat;
  const groupName =
    groupList.find((findItem) => findItem.groupId === groupId)?.groupName ?? "";
  return { groupName };
};

export const isGroupMuted = (groupId) => {
  if (!groupId) return false;
  const { unreadChatMessage = [] } = store.getState()?.chat || {};
  const match = unreadChatMessage.find(
    (item) => item.id === groupId || item.user_id === groupId,
  );
  return Boolean(match?.group_mute);
};

export const sendNotificationHandler = async (notificationData, navigate) => {
  const state = store.getState();
  const { unreadChatMessage } = state.chat;
  const { user_unique_key: senderID } = getAuthSession();

  const isDoNotDisturbEnabled =
    state.authUserDetail?.authSessionUser?.isDoNotDisturbEnabled;

  if (notificationData) {
    let {
      senderID: notificationsenderID,
      receiverID,
      type: notificationType,
      message,
      event_type,
      original_message,
      documentID,
      parent_id,
    } = notificationData;
    let type = "";
    if (notificationType === "private" && event_type === "msg-notification") {
      type = "one-to-one-chat";
    } else if (
      notificationType === "group" &&
      event_type === "msg-notification"
    ) {
      type = "group-chat";
    } else if (
      notificationType === "private" &&
      event_type === "call-notification"
    ) {
      type = "one-to-one-call";
    } else if (
      notificationType === "group" &&
      event_type === "call-notification"
    ) {
      type = "group-call";
    } else if (
      notificationType === "schedule" &&
      event_type === "call-notification"
    ) {
      type = "schedule-call";
    }
    if (type) {
      const { sender, useravtar } = await notificationAttendeeDetail(
        notificationsenderID,
      );
      if (type === "one-to-one-call") {
        if (!isDoNotDisturbEnabled) {
          if (isElectron) {
            notifyDesktopApp(
              CALL_TITLE,
              `From: ${sender}`,
              sender,
              "one-to-one-call",
              useravtar,
            );
            return;
          }

          PushNotification.showIncomingCallNotification(sender, useravtar);
        }
      } else if (type === "one-to-one-chat") {
        if (!isDoNotDisturbEnabled) {
          // if user chat window opened than his corresponding message notification will not receive

          if (isElectron) {
            notifyDesktopApp(
              `New Message from ${sender}`,
              message,
              sender,
              "one-to-one-message",
              useravtar,
              documentID,
              parent_id,
            );
            return;
          }

          PushNotification.showIncomingTextMessageNotification(
            sender,
            message,
            useravtar,
            () => {
              navigate({
                pathname: "/",
                search: new URLSearchParams({
                  chatroom: documentID,
                  type: notificationType,
                  parent_id,
                }).toString(),
              });
            },
          );
        }
      } else if (type === "group-call") {
        const { groupName } = await getGroupDetail(receiverID);
        // checking either user exist in group
        if (groupName != "") {
          const isGroupMute = isGroupMuted(receiverID);
          if (!isDoNotDisturbEnabled && !isGroupMute) {
            PushNotification.showIncomingGroupCallNotification(
              sender,
              useravtar,
              groupName,
            );
            notifyDesktopApp(
              CALL_TITLE,
              `From: ${sender} in ${groupName} Group`,
              sender,
              "group-call",
              useravtar,
            );
          }
        }
      } else if (type === "schedule-call") {
        if (!isDoNotDisturbEnabled) {
          if (!isElectron) {
            notifyDesktopApp(
              CALL_TITLE,
              `From: ${sender} in ${notificationData?.scheduleName} Scheduled`,
              sender,
              "group-call",
              useravtar,
            );

            return;
          }

          PushNotification.showIncomingGroupCallNotification(
            sender,
            useravtar,
            notificationData?.scheduleName,
          );
        }
      } else if (type === "group-chat") {
        const { groupName } = await getGroupDetail(receiverID);
        // checking either user exist in group
        if (groupName != "") {
          const NotificationSoundSettingData = unreadChatMessage;
          const notificationSoundSettingElement =
            NotificationSoundSettingData.filter(
              (filterItem) =>
                filterItem.id === receiverID ||
                filterItem.user_id === receiverID,
            );
          const groupMute =
            notificationSoundSettingElement.length > 0
              ? notificationSoundSettingElement[0]?.group_mute ?? false
              : false;
          const isALLTagged = original_message?.match("all_c2p_tagged");
          if (
            groupMute === false ||
            (isALLTagged !== null && isALLTagged.length > 0)
          ) {
            if (!isDoNotDisturbEnabled) {
              if (isElectron) {
                notifyDesktopApp(
                  `💬 ${groupName} Group - ${sender} `,
                  message,
                  sender,
                  "group-message",
                  useravtar,
                  documentID,
                  parent_id,
                );
                return;
              }

              PushNotification.showIncomingGroupChatNotification(
                sender,
                message,
                useravtar,
                groupName,
                receiverID,
                () =>
                  navigate({
                    pathname: "/",
                    search: new URLSearchParams({
                      chatroom: documentID,
                      type: notificationType,
                      parent_id,
                    }).toString(),
                  }),
              );
            }
          } else {
            const isUserTagged = original_message?.match(senderID);
            if (isUserTagged !== null && isUserTagged.length > 0) {
              if (!isDoNotDisturbEnabled) {
                PushNotification.showIncomingGroupChatNotification(
                  sender,
                  message,
                  useravtar,
                  groupName,
                  receiverID,
                );

                notifyDesktopApp(
                  `💬 ${groupName} Group - ${sender} `,
                  message,
                  sender,
                  "group-message",
                  useravtar,
                );
              }
            }
          }
        }
      }
    }
  }
};

export const openUserChat = (data, isTypeGroup) => {
  const { dispatch } = store;
  const state = store.getState();
  const { unreadChatMessage, chatSearchState, chatboardSelectedTab } =
    state.chat;
  const {
    user_unique_key: senderIDD,
    company_unique_key,
    user_unique_key,
  } = getAuthSession();
  const { allAttendeeList } = state.call;
  const { sidebarActiveData } = state.chat;

  dispatch(setReplyMessage({}));
  dispatch(setChatboardSelectedTab("messages"));

  const documentID = isTypeGroup
    ? data?.groupId
    : privateChatID([senderIDD, data?.user_id]);
  const search_id = isTypeGroup ? data?.groupId : data?.user_id;
  if (
    chatSearchState[search_id] !== undefined &&
    chatSearchState[search_id] !== "" &&
    chatboardSelectedTab === "search"
  ) {
    let searchedText = chatSearchState[search_id];
    if (searchedText.length > 0) {
      dispatch(setSearchChatData(searchedText));
      const Payload = {
        user_id: user_unique_key,
        company_id: company_unique_key,
        documentID: documentID,
        filter: searchedText,
      };
      _searchChatMessage(Payload);
    }
    if (!isTypeGroup) {
      if (sidebarActiveData !== data?.user_id) {
        dispatch(setLoaderActiveData(true));
        dispatch(setSearchChatData(""));
        dispatch(setIsChatHistoryEnableOnce(false));
        dispatch(setIsScrollingUp(false));
      }
      dispatch(
        setAttendeeData({ ...data, role_name: data?.role, type: "attendee" }),
      );
      dispatch(setSidebarActiveData(data?.user_id));
    } else {
      if (sidebarActiveData !== data?.groupId) {
        dispatch(setLoaderActiveData(true));
        dispatch(setSearchChatData(""));
        dispatch(setIsChatHistoryEnableOnce(false));
      }
      const userNameData = [];
      data?.attendeeId?.forEach((item) => {
        const filterUsername = allAttendeeList?.filter(
          (v) => v?.user_id === item,
        );
        if (filterUsername && filterUsername.length > 0) {
          userNameData.push(filterUsername[0].name);
        }
      });

      const username = userNameData.length > 0 ? userNameData.toString() : "";
      dispatch(setAttendeeData({ ...data, type: "group", username }));
      dispatch(setSidebarActiveData(data.groupId));
    }
  } else {
    _getMessageList(
      () => {
        if (!isTypeGroup) {
          if (sidebarActiveData !== data.user_id) {
            dispatch(setLoaderActiveData(true));
            dispatch(setSearchChatData(""));
            dispatch(setIsChatHistoryEnableOnce(false));
            dispatch(setIsScrollingUp(false));
          }
          dispatch(
            setAttendeeData({
              ...data,
              role_name: data.role,
              type: "attendee",
            }),
          );
          dispatch(setSidebarActiveData(data.user_id));
        } else {
          if (sidebarActiveData !== data.groupId) {
            dispatch(setLoaderActiveData(true));
            dispatch(setSearchChatData(""));
            dispatch(setIsChatHistoryEnableOnce(false));
          }
          const userNameData = [];
          data?.attendeeId?.forEach((item) => {
            const filterUsername = allAttendeeList?.filter(
              (v) => v?.user_id === item,
            );
            if (filterUsername && filterUsername.length > 0) {
              userNameData.push(filterUsername[0].name);
            }
          });

          const username =
            userNameData.length > 0 ? userNameData.toString() : "";
          dispatch(setAttendeeData({ ...data, type: "group", username }));
          dispatch(setSidebarActiveData(data.groupId));
        }
      },
      "",
      "",
      true,
    );
  }

  const prevChatMessage = [...unreadChatMessage];
  const msgIndex = prevChatMessage.findIndex(
    (obj) => obj.user_id === (!isTypeGroup ? data?.user_id : data?.groupId),
  );
  if (msgIndex !== -1) {
    const msgElement = prevChatMessage[msgIndex];
    if (msgElement.count !== 0) {
      prevChatMessage[msgIndex] = {
        company_id: company_unique_key,
        logged_user_id: senderIDD,
        user_id: msgElement?.user_id,
        count: 0,
        timestamp: msgElement.timestamp,
        notification_sound: msgElement?.notification_sound ?? true,
        group_mute: msgElement?.group_mute ?? false,
      };
      const newObj = {
        company_id: company_unique_key,
        logged_user_id: senderIDD,
        user_id: msgElement?.user_id,
        count: 0,
        timestamp: msgElement.timestamp,
        notification_sound: msgElement?.notification_sound ?? true,
        group_mute: msgElement?.group_mute ?? false,
      };
      _unreadMessageCountUpdate(newObj);
    }
  }
  dispatch(setUnreadChatMessage(prevChatMessage));
};

export const updateChatRoom = (type, senderID, receiverID) => {
  const state = store.getState();
  const { attendeeData } = state.chat;
  const { dispatch } = store;
  dispatch(
    setChatRoom(
      type == "group"
        ? attendeeData?.groupId
        : privateChatID([senderID, receiverID]),
    ),
  );
};

export const getMsgListCorrespondenceToRoom = () => {
  const state = store.getState();
  const { chatRoom } = state.chat;
  const { user_unique_key: user_id, company_unique_key: company_id } =
    getAuthSession();
  if (chatRoom != "") {
    const chatRoomPayload = {
      company_id: company_id,
      documentID: chatRoom,
      user_id: user_id,
    };
    _sendChatRoomDetail(chatRoomPayload, "getMsgListCorrespondenceToRoom");
    _getMessageList(() => { }, user_id, chatRoom, false);
    _getUnreadThreadList(() => { }, false);
  }
};

export const clearUnreadThreadCount = (chatRoom, parentMsgId, companyId) => {
  const state = store.getState();
  const { unreadThreadListObj } = state.chat;

  const existingThread = unreadThreadListObj?.[chatRoom];

  if (!existingThread || existingThread?.length === 0) return;

  const isParentExists = existingThread.some(
    (thread) => thread.parent_id === parentMsgId,
  );

  if (!isParentExists) return;

  store.dispatch(
    removeUnreadThread({
      chatRoom,
      parent_id: parentMsgId,
    }),
  );

  _sendClearUnreadThreadCount({
    parent_id: parentMsgId,
    documentID: chatRoom,
    company_id: companyId,
    count: 0,
  });
};

export const getMsgListCorrespondenceToRoomThread = () => {
  const state = store.getState();
  const { chatRoom, activeThreadChat } = state.chat;
  const { company_unique_key: company_id } = getAuthSession();
  if (chatRoom != "") {
    const chatRoomPayload = {
      company_id: company_id,
      documentID: chatRoom,
      parent_id: activeThreadChat[chatRoom]?.id,
    };
    _sendChatRoomThreadDetail(
      chatRoomPayload,
      "getMsgListCorrespondenceToRoomThread",
    );
    _getThreadMessageList(
      () => { },
      "",
      chatRoom,
      activeThreadChat[chatRoom]?.id,
      false,
    );

    clearUnreadThreadCount(
      chatRoom,
      activeThreadChat[chatRoom]?.id,
      company_id,
    );
  }
};

export const getChatMessageByGroup = async (newChatMessage) => {
  const { user_unique_key } = getAuthSession();
  let list = [];
  let dateSessions = "";
  let dateSessionsNewDate = "";
  await newChatMessage
    ?.slice(0)
    .reverse()
    .forEach((v) => {
      if (v.message !== "c2-attach-recording-file") {
        let timestampDate = timestampToDateTimeFilter(v.timestamp);
        if (timestampDate != dateSessions) {
          dateSessions = timestampDate;
          dateSessionsNewDate = timestampDate;
        } else {
          dateSessionsNewDate = "";
        }
        let groupDetails = {
          ...v,
          checkdate: dateSessionsNewDate,
        };
        list.push(groupDetails);
      } else {
        if (v.senderID === user_unique_key) {
          let timestampDate = timestampToDateTimeFilter(v.timestamp);
          if (timestampDate != dateSessions) {
            dateSessions = timestampDate;
            dateSessionsNewDate = timestampDate;
          } else {
            dateSessionsNewDate = "";
          }
          let groupDetails = {
            ...v,
            checkdate: dateSessionsNewDate,
          };
          list.push(groupDetails);
        }
      }
    });
  return list;
};

export const checkIsAttachmentsUploaded = (newChatMessage) => {
  const state = store.getState();
  const { dispatch } = store;
  const { attachmentData } = state.chat;
  if (attachmentData && attachmentData.length > 0) {
    attachmentData.forEach((attachmentItem) => {
      let check = false;
      newChatMessage
        ?.slice(0)
        .reverse()
        .forEach((chatMsg) => {
          if (
            chatMsg.attachments !== undefined &&
            // eslint-disable-next-line no-prototype-builtins
            chatMsg.attachments.constructor.prototype.hasOwnProperty("push") &&
            chatMsg.message === "c2-attach-files"
          ) {
            check = chatMsg?.attachments?.some(
              (v) => v.attachmentId === attachmentItem,
            );
          }
        });
      if (check && attachmentData.length > 0) {
        dispatch(setAttachmentData([]));
        dispatch(setIsUploadingData([]));
      }
    });
  }
};

export const OnClickOutside = (ref, handler) => {
  useEffect(() => {
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
};

export const replaceExistEmoji = (reactions, emojiIndex, userIndex) => {
  const reactionData = [];
  const reactionDataWithUpdating = [...reactions];
  if (reactionDataWithUpdating[emojiIndex].count > 1) {
    const selectedEmoji = { ...reactionDataWithUpdating[emojiIndex] };
    const UserID = [...selectedEmoji.user_id];
    UserID.splice(userIndex, 1);
    selectedEmoji.user_id = UserID;
    selectedEmoji.count = reactionDataWithUpdating[emojiIndex].count - 1;
    reactionDataWithUpdating[emojiIndex] = selectedEmoji;
    reactionData.push(...reactionDataWithUpdating);
  } else {
    reactionDataWithUpdating.splice(emojiIndex, 1);
    reactionData.push(...reactionDataWithUpdating);
  }
  return reactionData;
};

export const onEmojiClickCommonHandler = async (
  emojiObject,
  value,
  // setShowPicker,
  // setShowMessagePicker,
) => {
  const { user_unique_key: senderID } = getAuthSession();
  const { reactions, id } = value;
  const MessageData = { ...value };
  const reactionData = [];
  if (reactions === undefined || reactions.length === 0) {
    const reactionObject = {
      emoji: emojiObject.emoji,
      unified: emojiObject.unified,
      count: 1,
      user_id: [senderID],
      names: emojiObject.names,
    };
    reactionData.push(reactionObject);
  } else {
    const emojiIndex = reactions.findIndex(
      (item) => item.unified === emojiObject.unified,
    );
    if (emojiIndex !== -1) {
      const userIndex = reactions[emojiIndex]?.user_id?.findIndex(
        (item) => item === senderID,
      );
      if (userIndex !== -1) {
        const getUpdatedData = await replaceExistEmoji(
          reactions,
          emojiIndex,
          userIndex,
        );
        reactionData.push(...getUpdatedData);
      } else {
        const updatedReactions = [...reactions];
        const updatedSelectedEmoji = { ...updatedReactions[emojiIndex] };
        updatedSelectedEmoji.count = updatedReactions[emojiIndex].count + 1;
        const updatedUserID = [...updatedSelectedEmoji.user_id];
        updatedUserID.push(senderID);
        updatedSelectedEmoji.user_id = updatedUserID;
        updatedReactions[emojiIndex] = updatedSelectedEmoji;
        reactionData.push(...updatedReactions);
      }
    } else {
      const originalReactionData = [...reactions];
      const reactionObject = {
        emoji: emojiObject.emoji,
        unified: emojiObject.unified,
        count: 1,
        user_id: [senderID],
        names: emojiObject.names,
      };
      originalReactionData.push(reactionObject);
      reactionData.push(...originalReactionData);
    }
  }
  MessageData["reactions"] = reactionData;
  MessageData["messageID"] = id;
  await _editChatMessage(MessageData);
  // setShowPicker("");
  // setShowMessagePicker("");
};

export const getMentionUserProfile = (e, userId, msgId) => {
  const { dispatch } = store;
  if (userId && msgId) {
    // Detect if hover is inside thread panel by checking parent elements
    const isInThread = e.target?.closest?.(".thread_box") !== null;
    dispatch(setUserProfilePopPosition({ x: e.offsetX, y: e.offsetY }));
    dispatch(setMsgMentionUser(userId));
    dispatch(setMsgMentionId(msgId));
    dispatch(setIsMentionInThread(isInThread));
  }
};
export const pinnedUserProfileHover = (
  e = null,
  userId = null,
  msgId = null,
) => {
  const { dispatch } = store;
  if (userId && msgId) {
    dispatch(setUserProfilePopPosition({ x: e.offsetX, y: e.offsetY }));
    dispatch(setUserProfileId(msgId));
    dispatch(setPinnedByUserProfileId(userId));
  } else {
    dispatch(setUserProfilePopPosition({ x: 0, y: 0 }));
    dispatch(setUserProfileId(""));
    dispatch(setPinnedByUserProfileId(""));
  }
};

export const removeMentionUserProfile = () => {
  const state = store.getState();
  const { isCursorOnUserProfile } = state.chat;

  setTimeout(() => {
    if (!isCursorOnUserProfile) {
      clearMentionedUserProfileStates();
    }
  }, 2000);
};

export const clearMentionedUserProfileStates = () => {
  const { dispatch } = store;
  dispatch(setMsgMentionUser(""));
  dispatch(setMsgMentionId(""));
  dispatch(setIsMentionInThread(false));
  dispatch(setUserProfilePopPosition({ x: 0, y: 0 }));
};

export const SortBasedOnNames = (a, b) => {
  if (a.label && b.label) {
    let nameA = a.label.toUpperCase();
    let nameB = b.label.toUpperCase();
    if (nameA > nameB) {
      return 1;
    }
    if (nameA < nameB) {
      return -1;
    }
    return 0;
  }
};

export const userProfileHover = (id, forThread) => {
  const { dispatch } = store;
  const textArea = document
    .getElementById("text")
    ?.getBoundingClientRect()?.top;

  let handleMouseMove = (event) => {
    let mouseY = event.pageY;
    let totalCal = Math.floor(textArea) - Number(mouseY);
    totalCal < 210
      ? dispatch(setPopupClass("chat-user-profile"))
      : dispatch(setPopupClass(""));
  };
  let element = document.getElementById(id);
  if (id && element) {
    element?.addEventListener("mouseenter", handleMouseMove);

    // dispatch(setUserProfileId(id));
    if (forThread) {
      dispatch(setUserProfileHoverId({ thread: id }));
    } else {
      dispatch(setUserProfileId(id));
    }
  } else {
    element?.removeEventListener("mouseleave", handleMouseMove);
    dispatch(setUserProfileId({}));
    dispatch(setUserProfileHoverId({}));
  }
};

export const getReactionUserName = (user_id) => {
  var userName = [];
  const state = store.getState();
  const { allAttendeeList } = state.call;
  for (var i = 0; i < user_id?.length; i++) {
    var promise = new Promise((resolve) => {
      let userData = user_id[i];
      const particularUser = allAttendeeList?.find(
        (attendee) => attendee.user_id === userData,
      );
      resolve(particularUser?.name);
    });
    userName.push(promise);
  }
  return Promise.all(userName);
};

export const getMultipleImagesData = async (data) => {
  const imagesData = [];
  data.forEach((item) => {
    if (item.message === "c2-attach-files") {
      item.attachments.forEach((attachmentItem) => {
        if (
          attachmentItem?.attachment_type == "png" ||
          attachmentItem?.attachment_type == "jpg" ||
          attachmentItem?.attachment_type == "jpeg" ||
          attachmentItem?.attachment_type == "jfif"
        ) {
          let id = attachmentItem?.attachmentName?.split(".")[0];
          imagesData.push({
            id: id,
            filename: attachmentItem?.attachmentName,
            attachment_expire_seconds: item.attachment_expire_seconds,
            timestamp: item.timestamp,
          });
        }
      });
    }
  });
  storeMultipleImagesData(imagesData);
};

export const storeMultipleImagesData = async (data) => {
  const { dispatch } = store;
  const state = store.getState();
  const { authSessionUser } = state.authUserDetail;
  data?.reverse()?.forEach(async (item) => {
    const downloadUrl = `${UPLOAD_API_URL}download`;
    const getWasabiUrl = await fetchWasabiImageUploadURL(downloadUrl, {
      file: item?.filename,
      attachment_expire_seconds: item?.attachment_expire_seconds ?? "",
      timestamp: item?.timestamp ?? "",
      company_id: authSessionUser?.company_id,
    });
    if (getWasabiUrl?.status === 200) {
      const url = getWasabiUrl?.data?.url;
      fetch(url)
        .then((res) => {
          return res.blob();
        })
        .then(async (blob) => {
          const tmpItem = { ...item, isExpired: false };
          const base64 = await blobToBase64(blob);
          tmpItem["image"] = base64;

          dispatch(addFileData(tmpItem));
        });
    } else {
      const tmpItem = { ...item, isExpired: true };
      tmpItem["image"] = "";
      dispatch(addFileData(tmpItem));
    }
  });
};

export const UrlPreview = (preview) => {
  return (
    <>
      {Array.isArray(preview)
        ? preview.map((item, index) => (
          <div key={index}>{UrlPreviewView(item)}</div>
        ))
        : Object.keys(preview).length > 0
          ? UrlPreviewView(preview)
          : null}
    </>
  );
};

export const UrlPreviewView = (preview) => {
  return (
    <div className="d-flex flex-column pt-1 pl-3 mt-2 border-left">
      {preview.url !== "" && <p>{preview.url}</p>}
      {preview?.title !== "" && <p className="text-orange">{preview?.title}</p>}
      {preview.description !== "" && (
        <p className="mt-1 text-grey">{preview.description}</p>
      )}
      {preview.image !== "" &&
        (preview.image.indexOf("http://") == 0 ||
          preview.image.indexOf("https://") == 0) ? (
        <div className="mt-2 border-radius w-30 overflow-hidden border-light">
          <img className="w-100 h-100" src={preview.image} />
        </div>
      ) : null}
    </div>
  );
};

export const previewLinkIcon = (value) => {
  return (
    <>
      {value?.preview ? (
        Array.isArray(value?.preview) ? null : Object.keys(value?.preview)
          .length > 0 ? (
          // eslint-disable-next-line react/jsx-no-target-blank
          <a href={value?.preview?.url} target="_blank" className="text-dark">
            <svg viewBox="3 3 18 18" width="12" fill="currentColor">
              <path d="m13 3 3.293 3.293-7 7 1.414 1.414 7-7L21 11V3z"></path>
              <path d="M19 19H5V5h7l-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-5l-2-2v7z"></path>
            </svg>
          </a>
        ) : null
      ) : null}
    </>
  );
};

export const parseEmoji = (str) => {
  // const rex =
  //   /[\u{1f300}-\u{1f5ff}\u{1f900}-\u{1f9ff}\u{1f600}-\u{1f64f}\u{1f680}-\u{1f6ff}\u{2600}-\u{26ff}\u{2700}-\u{27bf}\u{1f1e6}-\u{1f1ff}\u{1f191}-\u{1f251}\u{1f004}\u{1f0cf}\u{1f170}-\u{1f171}\u{1f17e}-\u{1f17f}\u{1f18e}\u{3030}\u{2b50}\u{2b55}\u{2934}-\u{2935}\u{2b05}-\u{2b07}\u{2b1b}-\u{2b1c}\u{3297}\u{3299}\u{303d}\u{00a9}\u{00ae}\u{2122}\u{23f3}\u{24c2}\u{23e9}-\u{23ef}\u{25b6}\u{23f8}-\u{23fa}]/gu;
  /* eslint-disable */
  const regx =
    /\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC68(?:\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|[\u2695\u2696\u2708]\uFE0F|\uD83D[\uDC66\uDC67]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708])\uFE0F|\uD83C[\uDFFB-\uDFFF])|\uD83E\uDDD1(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFB-\uDFFE])|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFC-\uDFFF])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83C\uDFF3\uFE0F\u200D\u26A7|\uD83E\uDDD1(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDC3B\u200D\u2744|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F\u200D[\u2640\u2642]|(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642])|\uD83C\uDFF4\u200D\u2620|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E-\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3C-\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDF])\u200D[\u2640\u2642])\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC08\u200D\u2B1B|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|[#\*0-9]\uFE0F\u20E3|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5-\uDED7\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDD77\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g;
  const updated = str.replace(
    regx,
    (match) => `<span class="emoji-style">${match}</span>`,
  );

  return updated;
};

export const updateThreadChatMessageObj = (
  prevObj,
  chatRoomId,
  parentMsgId,
  message,
) => {
  if (!chatRoomId || !parentMsgId || !message) return prevObj;

  const key = `${chatRoomId}_${parentMsgId}`;
  const parentThread = prevObj[key] || [];

  const isSameMessage = (m) =>
    (message.msgUniqueID && m.msgUniqueID === message.msgUniqueID) ||
    m.id === message.id;

  const index = parentThread.findIndex(isSameMessage);

  let updatedThread;

  if (index !== -1) {
    // 🔁 Replace at same position
    updatedThread = parentThread.map((m, i) => (i === index ? message : m));
  } else {
    // ➕ Insert and keep timestamp order
    updatedThread = [message, ...parentThread];
  }

  return {
    ...prevObj,
    [key]: updatedThread,
  };
};

export const updateMessageIndexDb = async (message) => {
  if (message && message?.documentID) {
    const chatMessagesData = await getData(message?.documentID);

    if (chatMessagesData && chatMessagesData?.list) {
      const newList = [...chatMessagesData?.list];

      //for thread
      if (message?.thread_id && message?.parent_id) {
        const parentMsgIdIndex = newList.findIndex(
          (findItem) => findItem.id === message.parent_id,
        );

        newList[parentMsgIdIndex] = {
          ...newList[parentMsgIdIndex],
          thread: true,
        };
      }
      /////

      const index = chatMessagesData?.list.findIndex(
        (item) => item.id === message.id,
      );

      if (index !== -1) {
        if (!message?.deleted) {
          newList[index] = message;
        } else {
          newList.splice(index, 1);
        }
      } else {
        newList.unshift(message);
      }
      const payload = {
        id: message?.documentID,
        list: newList,
      };
      updateDataInDB(payload);
    }
  }
};

export const addchatHistoryIndexDb = async (data) => {
  if (data && data.length > 0) {
    const chatRoom = data[0]?.documentID ?? "";
    const chatMessagesData = await getData(chatRoom);
    if (chatMessagesData && chatMessagesData?.list) {
      const newList = [...chatMessagesData?.list];
      newList.push(...data);
      const payload = {
        id: chatRoom,
        list: newList,
      };
      updateDataInDB(payload);
    }
  }
};

export const displayEmoji = (emojiObject, view = "") => {
  if (!emojiObject || !emojiObject.names || emojiObject.names.length === 0) {
    return emojiObject?.emoji;
  }

  const [firstName, displayName] = emojiObject.names;

  if (firstName.startsWith("flag-")) {
    const code = firstName.split("-")[1]?.toLowerCase();
    const altText = displayName || firstName;

    const size = view === "popover" ? "24x18" : "16x12";

    return (
      <img src={`https://flagcdn.com/${size}/${code}.png`} alt={altText} />
    );
  }

  return emojiObject?.emoji;
};

export const getPinnedData = (chatRoom) => {
  const state = store.getState();
  return state.chat.pinnedMessages[chatRoom] || [];
};

export const updatePinnedMessagesStore = (doc) => {
  const chatRoom = doc?.documentID;
  const state = store.getState();
  const {
    pinnedMessages,
    chatRoom: currentChatRoom,
    chatboardSelectedTab,
  } = state.chat;

  let roomMessages = Array.isArray(pinnedMessages[chatRoom])
    ? [...pinnedMessages[chatRoom]]
    : [];

  if (doc.deleted) {
    roomMessages = roomMessages.filter((msg) => msg.id !== doc.id);
  } else if (doc.pinned === true) {
    const exists = roomMessages.some((msg) => msg.id === doc.id);
    if (!exists) {
      if (roomMessages.length === 0 && chatboardSelectedTab !== "pins") {
        return;
      }
      roomMessages.unshift(doc);
    } else {
      roomMessages = roomMessages.map((msg) =>
        msg.id === doc.id ? { ...msg, ...doc } : msg,
      );
    }
  } else if (doc.pinned === false) {
    roomMessages = roomMessages.filter((msg) => msg.id !== doc.id);
  } else {
    roomMessages = roomMessages.map((msg) =>
      msg.id === doc.id ? { ...msg, ...doc } : msg,
    );
  }
  store.dispatch(updatePinnedMessages({ chatRoom, data: roomMessages }));
  if (currentChatRoom === chatRoom) {
    store.dispatch(setPinnedChatMessage(roomMessages));
  }
};

export const getFilesData = (chatRoom) => {
  const state = store.getState();
  return state.chat.filesMessages[chatRoom] || [];
};

export const updateFilesMessagesStore = (doc) => {
  const chatRoom = doc?.documentID;
  const state = store.getState();
  const {
    filesMessages,
    chatRoom: currentChatRoom,
    chatboardSelectedTab,
  } = state.chat;

  if (!doc.files) {
    return;
  }

  let roomMessages = Array.isArray(filesMessages[chatRoom])
    ? [...filesMessages[chatRoom]]
    : [];

  if (doc.deleted) {
    roomMessages = roomMessages.filter((msg) => msg.id !== doc.id);
  } else {
    const exists = roomMessages.some((msg) => msg.id === doc.id);
    if (exists) {
      roomMessages = roomMessages.map((msg) =>
        msg.id === doc.id ? { ...msg, ...doc } : msg,
      );
    } else {
      roomMessages.unshift(doc);
    }
  }

  store.dispatch(updateFilesMessages({ chatRoom, data: roomMessages }));
  if (currentChatRoom === chatRoom && chatboardSelectedTab === "files") {
    store.dispatch(setChatFiles(roomMessages));
  }
};
